import { AmpConfig } from './amp-config.types';
import { isLocalEnvByUrl } from './constants';

const ROOT_PATH = '/home/educator';

let ampConfig: AmpConfig | null = null;

export const fetchAmpConfig = async () => {
  const ampConfigPath = isLocalEnvByUrl() ? ROOT_PATH : '';

  const res = await fetch(
    `${window.location.origin}${ampConfigPath}/amp-config.json`,
    {
      headers: {
        Accept: 'application/json',
      },
    },
  );

  ampConfig = await res.json();
};

export const getAmpConfig = () => {
  if (!ampConfig) {
    throw new Error('AmpConfig not loaded');
  }

  return ampConfig;
};

export const getAmpConfigFlags = () => getAmpConfig().flags['educator-home'];
